var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkillsi = function SvgSkillsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m20.5 8.233-8.229-3.182a.75.75 0 0 0-.542 0L3.5 8.233a.8.8 0 0 0 0 1.489l3.243 1.254v5.378a.8.8 0 0 0 .226.562A7.52 7.52 0 0 0 12 19a7.52 7.52 0 0 0 5.031-2.084.8.8 0 0 0 .226-.562v-5.378l1.172-.453v3.757a.771.771 0 1 0 1.542 0V9.934c0-.037 0 .036 0 0l.528-.212a.8.8 0 0 0 0-1.489zm-4.784 7.762A5.95 5.95 0 0 1 12 17.409a6 6 0 0 1-3.715-1.416v-4.421l3.444 1.328a.75.75 0 0 0 .542 0l3.444-1.332zM12 11.31 5.969 8.978 12 6.645l6.031 2.333z",
    "data-name": "Path 4343"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkillsi);
export default ForwardRef;